import { render, staticRenderFns } from "./OrganizationSelectedDisplay.vue?vue&type=template&id=1d9a3c5a&scoped=true&"
import script from "./OrganizationSelectedDisplay.vue?vue&type=script&setup=true&lang=js&"
export * from "./OrganizationSelectedDisplay.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9a3c5a",
  null
  
)

export default component.exports